import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'tools-help-modal',
  imports: [MatDialogModule],
  templateUrl: './tools-help-modal.component.html',
  styleUrl: './tools-help-modal.component.css'
})
export class ToolsHelpModalComponent {
}
